import React, { useEffect, useState } from 'react'
import Header from './CashbackHeader'
import MaterialTable from '@material-table/core'
import * as UIcons from '@iconscout/react-unicons'
import { useDispatch, useSelector } from 'react-redux'
import EmptyCashback from './EmptyCashback'
import { getResponse, previewModal, showModal } from 'store/slices/miscSlice'
// import AddCashback from './AddCashback'
// import { CashbackValidation } from 'pages/Settings/validation'
import TableActionBtn from 'components/TableActionBtn'
import { Trans, withTranslation } from 'react-i18next'
import PreviewCashBack from './PreviewCashBack'
// import Icons from 'includes/Icons'
import useSWR, { mutate } from 'swr'
import { BsChevronDown } from 'react-icons/bs'
import useBranch from 'hooks/useBranch'
import Spinner from 'components/Spinner'

export default withTranslation()(function CashBackTable({ t }) {
  const { data: cashbacks } = useSWR('settings/cashbacks')
  const { branches: branch } = useBranch()
  const [suspended, setSuspended] = useState({})
  const { response } = useSelector(state => state?.misc)
  const dispatch = useDispatch()
  useEffect(() => { mutate('settings/cashbacks') }, [response])
  const getBranchName = id => branch?.data?.find(x => x.id === id)?.name

  return (
    <>
      {
        !cashbacks?.data || cashbacks.length === 0 ? (
          <Spinner />
        ) : (
          <div className="p-5 bg-white rounded-xl">
            {
              cashbacks.length === 0 ? <EmptyCashback /> :
                <MaterialTable
                  title=''
                  columns={[
                    { title: t('settings.cashback.branch'), field: '', render: ({ branch_id }) => getBranchName(branch_id) },
                    { title: t('settings.cashback.start'), field: 'start' },
                    { title: t('settings.cashback.end'), field: 'end' },
                    { title: t('settings.cashback.percentage'), field: 'bonus_percentage', render: ({ fixed_bonus, bonus_percentage }) => <span>{fixed_bonus || bonus_percentage}</span> },
                    {
                      title: t('misc.status'),
                      field: 'status',
                      render: ({ status, tableData: { id } }) => {
                        return (
                          <div className='relative'>
                            <div onClick={() => setSuspended({ [id]: !suspended[id] })}
                              className={`rounded border w-[fit-content] px-3 capitalize py-1 flex items-center justify-between gap-[10px] cursor-pointer
                      ${status === 'active' ? 'text-[green] border-[green]' : 'text-red-400 border-red-400'}`} >
                              {status} <BsChevronDown />
                            </div>
                            {suspended[id] && (
                              <div onClick={() => setSuspended({ [id]: false })}
                                className='bg-white shadow text-center rounded-b py-2 absolute px-2 z-[1000] top-[35px] min-w-[95px] cursor-pointer'>
                                Suspend
                              </div>
                            )}
                          </div>
                        )
                      }
                    },
                    { title: t('settings.cashback.is_fixed'), field: 'is_fixed', render: ({ is_fixed }) => is_fixed === 1 ? 'Yes' : 'No' },
                  ]}
                  options={{
                    actionsColumnIndex: -1
                  }}
                  // icons={Icons}
                  actions={[
                    {
                      icon: (e, iconProps) => <div className="relative">

                        {/* {console.log('icon props', iconProps)} */}
                        <UIcons.UilEllipsisH className="text-primary" />
                        <ul className={` bg-white shadow-lg border w-36 rounded-lg absolute -right-4`}>
                          <li className="p-3 text-sm">View cashback</li>
                        </ul>
                      </div>,
                      tooltip: 'View details',
                      onClick: (e, tableProps) => {
                        // console.log('Table props', tableProps)

                      }
                    }
                  ]}
                  data={cashbacks?.data.data ?? []}
                  components={{
                    Toolbar: props => (
                      <>
                        <Header />
                      </>
                    ),
                    Action: ({ data }) => (
                      <>
                        <TableActionBtn
                          data={[
                            {
                              Content: {
                                icon: UIcons.UilEye,
                                text: t('misc.view_details')
                              },
                              action: () => {
                                dispatch(previewModal({
                                  title: `${t('settings.cashback.details_title')}`,
                                  content: () => <PreviewCashBack tableProps={{
                                    start: data.start,
                                    end: data.end,
                                    bonus_percentage: data.bonus_percentage,
                                    is_fixed: data.is_fixed,
                                    fixed_bonus: data.fixed_bonus,
                                    status: <span className="text-green">{data.status}</span>
                                  }}
                                  />
                                }))
                              }
                            },
                            // {
                            //   Content: {
                            //     icon: UIcons.UilEditAlt,
                            //     text: t('misc.edit_details')
                            //   },
                            //   action: () => dispatch(
                            //     showModal(
                            //       {
                            //         title: t('settings.cashback.edit'),
                            //         content: AddCashback,
                            //         dispacthAction: '',
                            //         url: `settings/cashbacks/${data.id}`,
                            //         values: {
                            //           is_fixed: data.is_fixed,
                            //           branch_id: data.branch_id,
                            //           start: data.start,
                            //           end: data.end,
                            //           bonus_percentage: data.bonus_percentage
                            //         },
                            //         method: 'put',
                            //         validation: CashbackValidation
                            //       }
                            //     )
                            //   )
                            // },
                            {
                              Content: {
                                icon: UIcons.UilTrash,
                                text: t('misc.delete'),
                                classList: 'text-failure'
                              },
                              action: () => {
                                dispatch(getResponse(`cashback_delete_${data.id}`));
                                dispatch(
                                  showModal(
                                    {
                                      title: t('settings.cashback.delete'),
                                      content: () => <div className="text-md w-full text-center">
                                        <Trans i18nKey="confirm_action" name="role">
                                          You have triggered a <strong className="font-medium text-red-400">delete</strong> action, do you wish to continue with the deletion?
                                        </Trans>
                                      </div>,
                                      url: `settings/cashbacks/${data.id}`,
                                      method: 'delete',
                                      btnText: t('misc.continue'),
                                      disableBtn: false,
                                      successMsg: t('settings.cashback.delete_msg')
                                    }
                                  )
                                )
                              }
                            }
                          ]}
                        />
                      </>
                    ),
                  }}
                />
            }
          </div>
        )
      }
    </>
  )
})
